// extracted by mini-css-extract-plugin
module.exports = {"label":"AnswerExternally_label__3gUDl","editor":"AnswerExternally_editor__3PPL8","translationEditor":"AnswerExternally_translationEditor__kiAwZ"};